import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: 'Please identify all your current medical conditions',
    field: 'hairLossFollowup_archived_currentMedicalConditions',
    type: 'info',
    answer: {
      name: 'hairLossFollowup_archived_currentMedicalConditions_ans',
      type: 'text',
      placeholder: 'Medical conditions'
    }
  },
  {
    label: 'Please list all your current medications including dosages',
    field: 'hairLossFollowup_archived_currentMedications',
    type: 'info',
    answer: {
      name: 'hairLossFollowup_archived_currentMedications_ans',
      type: 'text',
      placeholder: 'Medications'
    }
  },
  {
    label: 'Please list all of your known allergies',
    field: 'hairLossFollowup_archived_knownAllergies',
    type: 'info',
    answer: {
      name: 'hairLossFollowup_archived_knownAllergies_ans',
      type: 'text',
      placeholder: 'Allergies'
    }
  },
  {
    label: 'What is your height in feet and inches?',
    field: 'hairLossFollowup_archived_height',
    type: 'info',
    answer: {
      name: 'hairLossFollowup_archived_height_ans',
      type: 'text',
      placeholder: 'Feet and inches'
    }
  },
  {
    label: 'What is your weight in pounds?',
    field: 'hairLossFollowup_archived_weight',
    type: 'info',
    answer: {
      name: 'hairLossFollowup_archived_weight_ans',
      type: 'number',
      placeholder: 'Pounds'
    }
  },
  {
    label:
      'Have there been any health changes, medication changes, ED visits or hospitalizations since your last check-in?',
    field: 'hairLossFollowup_archived_healthChanges',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'hairLossFollowup_archived_healthChanges_no',
          value: 'No'
        },
        {
          key: 'hairLossFollowup_archived_healthChanges_yes',
          value: 'Yes',
          answer: {
            type: 'text',
            rows: 3,
            name: 'hairLossFollowup_archived_healthChanges_yes_ans',
            placeholder: 'Please tell us more about the changes in your health'
          }
        }
      ]
    }
  },
  {
    label: 'How are you doing on the current medication?',
    field: 'hairLossFollowup_archived_medicationStatus',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'hairLossFollowup_archived_medicationStatus_well',
          value: 'Well'
        },
        {
          key: 'hairLossFollowup_archived_medicationStatus_notWell',
          value: 'Not well',
          answer: {
            type: 'text',
            rows: 3,
            name: 'hairLossFollowup_archived_medicationStatus_notWell_ans',
            placeholder: 'Please tell us more about what you are experiencing'
          }
        }
      ]
    }
  },
  {
    label: 'Have you had any side effects from the current medication?',
    field: 'hairLossFollowup_archived_medicationSideEffects',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'hairLossFollowup_archived_medicationSideEffects_no',
          value: 'No'
        },
        {
          key: 'hairLossFollowup_archived_medicationSideEffects_yes',
          value: 'Yes',
          answer: {
            type: 'text',
            rows: 3,
            name: 'hairLossFollowup_archived_medicationSideEffects_yes_ans',
            placeholder:
              'Please tell us more about the side effects you are experiencing'
          }
        }
      ]
    }
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'hairLossFollowup_archived_otherInformationOrQuestions',
    type: 'info',
    answer: {
      name: 'hairLossFollowup_archived_otherInformationOrQuestions',
      type: 'text',
      placeholder: ''
    }
  },
  {
    label: 'Consent Form for Hair Loss Treatment Followup',
    educationalSlide: `
    <h1>Consent: Hair Loss Treatment Followup</h1>

        <section>
            <h2>Purpose of Treatment</h2>
            <p>To address hair loss in both men and women through various medical interventions aimed at slowing hair loss, promoting new hair growth, and improving hair density and appearance.</p>
        </section>

        <section>
            <h2>Potential Benefits</h2>
            <ul>
                <li>Slowing down the progression of hair loss</li>
                <li>Stimulating new hair growth</li>
                <li>Enhancing the thickness and appearance of existing hair</li>
                <li>Improving self-esteem and quality of life</li>
            </ul>
        </section>

        <section>
            <h2>Contraindications</h2>
            <p>Certain treatments may not be suitable for individuals with:</p>
            <ul>
                <li>Specific medical conditions (e.g., liver disease, kidney disease, hormonal imbalances)</li>
                <li>Allergies to medications or their components</li>
                <li>Pregnancy or breastfeeding</li>
                <li>Scalp conditions such as dermatitis or psoriasis</li>
            </ul>
        </section>

        <section>
            <h2>Potential Risks and Side Effects</h2>
            <ul>
                <li>Scalp irritation, itching, or dryness</li>
                <li>Hormonal changes</li>
                <li>Unwanted hair growth in unintended areas</li>
                <li>Electrolyte imbalances</li>
                <li>Mood changes or depression</li>
                <li>Allergic reactions</li>
                <li>Changes in blood pressure or heart rate</li>
                <li>Decreased libido and/or erectile dysfunction in men</li>
            </ul>
        </section>

        <section>
            <h2>Monitoring and Follow-up</h2>
            <p>Regular monitoring is recommended to assess effectiveness and detect any side effects. This may include physical examinations and laboratory tests as deemed necessary by your healthcare provider. Inform your provider of any adverse reactions or concerns.</p>
        </section>

        <section>
            <h2>Alternative Treatments</h2>
            <ul>
                <li>Hair transplant surgery</li>
                <li>Low-level laser therapy</li>
                <li>Platelet-rich plasma (PRP) therapy</li>
                <li>Lifestyle adjustments and acceptance of hair loss</li>
            </ul>
        </section>

        <section>
            <h2>Consent for Other Treatments</h2>
            <p>By signing this consent form, you agree to the use of medications or treatments as recommended by your healthcare provider for the management of hair loss. All treatments, including those not specifically mentioned above, will be discussed with you, including their potential benefits and risks.</p>
        </section>

        <section>
            <h2>Patient Responsibilities</h2>
            <ul>
                <li>Use treatments exactly as prescribed</li>
                <li>Report any side effects promptly</li>
                <li>Keep all follow-up appointments</li>
                <li>Inform your provider of any changes in your health status or medications</li>
            </ul>
        </section>

        <section>
            <p>By selecting below, you understand the potential risks and benefits of using enclomiphene and the off-label nature of this treatment. You agree to follow the monitoring plan and inform your healthcare provider of any side effects or concerns.</p>
        </section>

        <footer>
            <p>Copyright © 2024 Beluga Health. All Rights Reserved.</p>
            <p>This document and its contents are protected by copyright law. Clients of Beluga Health are granted permission to copy the content solely for the purpose of integrating with Beluga Health services and systems. Any other use, reproduction, distribution, or transmission of this document or its content, in whole or in part, is strictly prohibited without the prior written permission of Beluga Health. For permission requests, contact Beluga Health at <a href="mailto:info@belugahealth.com">info@belugahealth.com</a>.</p>
        </footer>
        `,
    field: 'hairLossFollowup_archived_consent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'hairLossFollowup_archived_consent_agree',
          value:
            'I have read and understand the information and wish to proceed.'
        }
      ]
    }
  }
];

export default questionsModels;
